import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TeamMembersService {
  constructor(private http: HttpClient) {}

  getAllTeamMembers(data) {
    return this.http
      .post(`${environment.apiUrl}/team-members/all`, data)
      .pipe();
  }

  getAllRiders(data) {
    return this.http
      .post(`${environment.apiUrl}/team-members/all-riders`, data)
      .pipe();
  }

  getBranchTeamMembers(id) {
    return this.http
      .get(`${environment.apiUrl}/team-members/branch-team-members/${id}`)
      .pipe();
  }

  createTeamMember(data) {
    return this.http
      .post(`${environment.apiUrl}/team-member/create`, data)
      .pipe();
  }

  updateTeamMember(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/team-member/update/${id}`, data)
      .pipe();
  }

  deleteTeamMember(id) {
    return this.http
      .delete(`${environment.apiUrl}/team-member/delete/${id}`)
      .pipe();
  }
}
